module.exports = __webpack_public_path__ + "img/IN.c2e56210.svg";